var _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.665,
    y: 1.665,
    width: 13.67,
    height: 16.67,
    rx: 2.335,
    stroke: "#114A8F",
    strokeWidth: 1.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.665,
    y: 4.665,
    width: 13.67,
    height: 16.67,
    rx: 2.335,
    fill: "white",
    stroke: "#114A8F",
    strokeWidth: 1.33
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.407060014e680c117abccd21f5b4e63c.svg";
export { ForwardRef as ReactComponent };